export default "__VITE_ASSET__C$zUrbwj__"